import React from "react";
import { SITE } from "../lib/site";
import { HandHeart } from "lucide-react";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="home"
      data-testid="hero-section"
      className="relative hero-img min-h-screen flex items-end overflow-hidden"
    >
      {/* Dark overlay for mobile readability */}
      <div className="absolute inset-0 bg-black/35 sm:bg-black/20 pointer-events-none" />
      {/* Geometric overlay */}
      <div className="absolute inset-0 islamic-pattern opacity-40 pointer-events-none" />

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16 pb-32 sm:pb-24 pt-32 sm:pt-40 w-full">
        <div className="max-w-3xl">
          <h1
            data-testid="hero-headline"
            className="font-serif-display text-white text-[2.5rem] leading-[1.05] sm:text-6xl lg:text-7xl tracking-tight font-semibold rise rise-delay-1"
          >
            Lifting widows, sheltering orphans,{" "}
            <span className="italic text-[#FCD34D]">restoring hope.</span>
          </h1>

          <p
            data-testid="hero-sub"
            className="mt-6 sm:mt-8 max-w-2xl text-base sm:text-xl text-white/85 leading-relaxed rise rise-delay-2"
          >
            Alisaafaat Welfare Foundation channels your Zakat, Sadaqaat and Waqf into
            education, orphan care, women's empowerment, healthcare and halal
            livelihoods — serving humanity with dignity.
          </p>

          <div className="mt-8 sm:mt-10 flex rise rise-delay-3">
            <button
              onClick={() => scrollTo("donate")}
              data-testid="hero-donate-btn"
              className="cta-shimmer inline-flex items-center justify-center gap-2 rounded-full bg-[#DC2626] hover:bg-[#B91C1C] text-white px-7 py-3.5 sm:py-4 text-sm font-semibold tracking-wide shadow-lg shadow-black/20 transition-all hover:scale-[1.02]"
            >
              <HandHeart size={18} strokeWidth={2.25} />
              Donate Now
            </button>
          </div>

          {/* Inline stat */}
          <div className="mt-12 sm:mt-16 rise rise-delay-4">
            <div className="inline-block border-l-2 border-[#D4AF37] pl-4">
              <div className="font-serif-display text-4xl sm:text-5xl text-white font-semibold">
                100+
              </div>
              <div className="text-[11px] uppercase tracking-[0.18em] text-white/80 mt-1 font-semibold">
                Beneficiaries
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Marquee strip at bottom */}
      <div className="absolute bottom-0 inset-x-0 z-10 bg-[#064E3B]/90 backdrop-blur-sm border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-6 md:px-12 lg:px-16 py-3 flex flex-col sm:flex-row sm:flex-wrap sm:items-center sm:justify-between gap-1 sm:gap-3">
          <p className="text-white/90 text-[11px] sm:text-sm font-medium italic font-serif-display line-clamp-2 sm:line-clamp-none">
            "{SITE.verse.text.slice(0, 90)}…"
          </p>
          <p className="text-[#FCD34D] text-[10px] sm:text-xs font-semibold tracking-wide">
            {SITE.verse.cite}
          </p>
        </div>
      </div>
    </section>
  );
}
